import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
interface AboutToBeRemovedProps {
    message: string
};


const DeleteDate = (props: AboutToBeRemovedProps) => {
    return (
        <div style={{ padding: '10px 20px', }} className="mb-4 bg-warning">
            {props.message}
            <a href="https://flowsync.se/help/flowsync/data-purging" target="_blank" rel='noreferrer'><FontAwesomeIcon className="documentation-icon" title="Visa hjälpavsnitt" icon="question-circle" /></a>
        </div>
    );
};

export default DeleteDate;
